export default __webpack_public_path__ + "static/media/thumbnail.63459a8f.png";